/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 * Widget report designer init translation
 *
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */

import { IWidgetReportsConstructorTranslation } from '@/main/modules/internationalization/types/pages/dashboard/widgetReportsConstructor';

export const initTranslationWidgetReportsConstructor: IWidgetReportsConstructorTranslation = {
	widgetTitle: '',
	title: '',
	text: '',
	btn: '',
};
